/* import __COLOCATED_TEMPLATE__ from './chart-bar.hbs.js'; */
import Component from '@glimmer/component';
export default class ChartBar extends Component {
  // Use ...attributes instead of args for SVG specific properties, ex: height
  get fill() {
    return this.args.fill || 'black';
  }
}